import { OutputRateBase } from './base/output-rate-base';

export class OutputRate extends OutputRateBase { }